'use client';
import { UserCircleIcon, GearSixIcon, CaretRightIcon } from '@phosphor-icons/react';

const ProfileSidebar = ({ currentScreen, onScreenChange }) => {
  const menuItems = [
    { id: 'my-profile', label: 'My Profile', icon: UserCircleIcon },
    { id: 'quizr-settings', label: 'Settings', icon: GearSixIcon },
  ];

  return (
    <div className="w-full max-w-sm mx-auto py-6 font-[Inter] pr-0">
      <h2 className="text-2xl font-bold px-4 ml-4 mb-6 mt-4 text-[var(--q3-neutral-default)]">Profile & Settings</h2>

      <nav className="flex flex-col gap-3 px-4">
        {menuItems.map((item) => {
          const isSelected = currentScreen === item.id;
          return (
            <button
              key={item.id}
              onClick={() => onScreenChange(item.id)}
              className={`group flex items-center justify-between px-4 py-3 text-sm font-medium leading-normal transition-colors duration-200 cursor-pointer
                ${
                  isSelected
                    ? 'bg-[var(--q3-neutral-default)] text-[var(--q3-neutral-default_inverted)]'
                    : 'bg-[var(--q3-surface-default)] text-[var(--q3-neutral-default)] hover:!bg-[var(--q3-surface-dimmer)]'
                }
                border border-transparent rounded-[12px] min-h-12 overflow-hidden`}
            >
              <div className="flex items-center gap-2 truncate">
                <item.icon size={18} className="transition-transform duration-200 group-hover:scale-105" />
                <span className="truncate">{item.label}</span>
              </div>
              <CaretRightIcon
                size={14}
                weight="bold"
                className="transition-transform duration-200 transform group-hover:translate-x-1"
              />
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default ProfileSidebar;
